import CardCommon from '@op/components/CardCommon';
import React, { useEffect, useState } from 'react';
import TopicItem from './TopicItem';
import { useResize } from '@op/hooks/useResize';
import { LanguageType } from '@op/types/common';
import { useTopicLevelOneList } from '@op/pages/Summary/hooks/useTopicConfig';
import { useTopicTrackingLoading } from '@op/models/loading/useTopicTrackingLoading';
import { TopicChartFilter } from '../TopicPerformanceFilter';

export default function TopicPerformanceLine({
  language,
  topicLevel,
  filter,
  setLanguage,
}: {
  language: LanguageType;
  topicLevel: string;
  filter: any;
  setLanguage: (language: LanguageType) => void;
}) {
  const { colSpan, refCallback } = useResize({
    itemWidth: 254,
    correctWidth: 60,
    defaultColSpan: 8,
  });
  const [topic2Select, setTopic2Select] = useState([]);
  const { tableData, loading, total } = useTopicLevelOneList({
    filter,
    topicLevel,
  });

  const { resetLoading } = useTopicTrackingLoading({
    key: 'topicTrackingTimeline',
  });

  useEffect(() => {
    resetLoading(tableData.length > 0);
  }, [tableData]);

  return (
    <CardCommon contentCard loading={loading} loadingHeight={300}>
      <TopicChartFilter
        setLanguageType={setLanguage}
        topicList={tableData}
        topic2Select={topic2Select}
        setTopic2Select={setTopic2Select}
      ></TopicChartFilter>
      <div ref={refCallback} className="dbo-topic-breakdown-wrapper">
        <CardCommon
          contentCard={tableData.length !== 0}
          empty={tableData.length === 0}
          emptyHeight={300}
        >
          {tableData.map(
            ({ topic, child_topics, ...data }: any, index: number) => (
              <TopicItem
                childTopics={child_topics}
                colSpan={colSpan}
                key={topic}
                title={topic}
                data={data}
                topic2Select={topic2Select}
                index={index + 1}
                language={language}
              ></TopicItem>
            ),
          )}
        </CardCommon>
      </div>
    </CardCommon>
  );
}
